/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';

function swapDragArrayElement(data, currentIndex, targetIndex) {
  var newData = _toConsumableArray(data);
  if (targetIndex - currentIndex > 0) {
    newData.splice(targetIndex + 1, 0, newData[currentIndex]);
    newData.splice(currentIndex, 1);
  } else {
    newData.splice(targetIndex, 0, newData[currentIndex]);
    newData.splice(currentIndex + 1, 1);
  }
  return newData;
}

export { swapDragArrayElement as default };
//# sourceMappingURL=swapDragArrayElement.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/_common/js/utils/swapDragArrayElement.js
// module id = null
// module chunks = 